module.exports = __webpack_public_path__ + "assets/5c8b42fa8d07036467d5cca0d9e8d771.png";